/** 设备激活相关接口 */
import request from '@/utils/util.request';

/*
 *  (activation) 加载页面数据
 *  @param {string} url：当前页面的完整url
 */
export const activation_loaddata = (data) => {
	return request({
		url: '/activation/loaddata',
		data,
	});
};

/*
 *  (activation) 扫码激活
 *  @param {string} code：扫码结果
 */
export const activation_scan_bind = (data) => {
	return request({
		url: '/activation/scanbind',
		data,
	});
};

/*
 *  (activation) 激活码激活
 *  @param {string} code：输入的激活码
 */
export const activation_code_bind = (data) => {
	return request({
		url: '/activation/codebind',
		data,
	});
};
